import type { IScope } from "angular";
import { finalize } from "rxjs/operators";

import type { IResponseWithLoading, ITeamSlim } from "App/Modules/Models";
import type { ISitesRepository } from "App/Modules/Repositories";
import { extendWithLoadingAndFail } from "App/Modules/Services/ObservableExtensions";

export default class TeamListComponentController {
    public static $inject: string[] = ["$scope", "mmSitesRepository"];

    public siteId: string;

    public teams: IResponseWithLoading<ITeamSlim[]>;

    constructor(private readonly $scope: IScope, private readonly sitesRepository: ISitesRepository) {}

    public $onInit() {
        this.teams = { isLoading: true };

        extendWithLoadingAndFail(this.sitesRepository.getTeamsForSite(this.siteId))
            .pipe(finalize(() => this.$scope.$applyAsync()))
            .subscribe(
                (response: IResponseWithLoading<ITeamSlim[]>) => {
                    if (!response.hasError && response.data) {
                        this.teams = response;
                    }
                },
                (errorResponse) => {
                    this.teams = errorResponse;
                },
            );
    }

    public teamsSubCaptionString(siteTeams: ITeamSlim[]) {
        return siteTeams.length > 0 ? siteTeams.map((st) => st.name).join(", ") : undefined;
    }
}
